function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.216826 4.90984C2.78513 3.92784 9.29548 1.28279 11.6115 0.339745C11.9752 0.191659 12.3585 0.501828 12.2917 0.888783L10.6387 10.4681C10.546 10.9777 9.94386 11.1629 9.57331 10.8387L6.74784 8.47642L5.14668 9.96587C5.01136 10.0917 4.79233 9.98246 4.81154 9.79865L5.07265 7.29942C5.07762 7.25191 5.09942 7.20775 5.13411 7.17492L11.1018 1.52853L3.80505 6.08903C3.73597 6.1322 3.69998 6.21296 3.71405 6.29319L3.97581 7.78521C4.01381 8.00181 3.72527 8.11216 3.60904 7.92548L2.62543 6.34573L0.309465 5.60463C-0.0610892 5.46567 -0.107408 5.00248 0.216826 4.90984Z",
  fill: "inherit",
  stroke: "none"
});

var SvgSend = function SvgSend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 11",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send.95f20279.svg";
export { ForwardRef as ReactComponent };